const addressOnNetwork: Record<number, string> = {
  // 4: '0x8015110874E64506F9BF2369f512Bbb10A8DFe57', // rinkeby testnet
  // 1666700000: '0xe96BBB4Ca62fBe2Dd02a971E251C6cb935680d15', // harmony testnet shard 0
  1666600000: '0x071a8d8abc34146a22001115999AAB50e8Bf0448', // harmony mainnet shard 0
};
export default addressOnNetwork;
